<template>
<Listbox v-model="selectedValue">
    <div class="relative">
    <p class="block font-bold text-sm text-gray-700">{{ label }}</p>
    <ListboxButton
        class="relative w-full py-2 pl-3 pr-10 cursor-pointer text-left bg-white rounded-md border shadow-sm focus:outline-none sm:text-sm"
        :class="{
            ['border-red-500 focus:border-red-600 focus:ring-offset-red-200 is-invalid'] : errorMessage,
            ['border-gray-300 focus:border-gray-400 focus:ring-offset-gray-300'] : !errorMessage,
            ['bg-gray-400 opacity-50'] : disabled,
        }"
    >
        <span
            :style="(selectedValue && selectedValue.family) ? 'font-family:' + selectedValue.family : ''"
            class="block truncate"
            :class="{
                ['text-gray-400 font-bold'] : !selectedValue,
                ['text-gray-600 font-bold'] : !selectedValue && disabled,
            }"
        >{{ selectedValue ? (selectedValue.name ? __(selectedValue.name) : __(selectedValue)) : __('Choose') }}</span>
        <span
        class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"
        >
        <SvgIcon
            name="selector"
            class="text-gray-700"
            :size="20"
        />
        </span>
    </ListboxButton>
    <div class="text-red-500 text-xs font-bold" v-if="errorMessage">{{ errorMessage }}</div>
    <slot />

    <transition
        leave-active-class="transition duration-100 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
    >
        <ListboxOptions
            v-if="!disabled"
            class="absolute w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-10"
        >
        <ListboxOption
            v-slot="{ active, selected }"
            value="None"
            v-if="noneOption"
            as="template"
        >
            <li
                :class="[
                    active ? 'text-red-900 bg-red-100' : 'text-gray-900',
                    'cursor-default select-none relative py-2 pl-10 pr-4',
                ]"
            >
            <span
                :class="[
                selected ? 'font-medium' : 'font-normal',
                'block truncate',
                ]"
                >{{ __('None') }}</span
            >
            <span
                v-if="selected"
                class="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600"
            >
                <SvgIcon
                    name="check"
                    :size="18"
                />
            </span>
            </li>
        </ListboxOption>
        <ListboxOption
            v-slot="{ active, selected }"
            v-for="item in data"
            :key="item.id"
            :value="item"
            as="template"
        >
            <li
                :class="[
                    active ? 'text-red-900 bg-red-100' : 'text-gray-900',
                    'cursor-default select-none relative py-2 pl-10 pr-4',
                ]"
                :style="item.family ? 'font-family:' + item.family : ''"
                class="flex items-center justify-between"
            >
            <span
                :class="[
                selected ? 'font-medium' : 'font-normal',
                'block truncate',
                ]"
                >{{ textBefore ? textBefore : ''}} {{ item.name ? __(item.name) : __(item) }} {{ textAfter ? textAfter : ''}}
                </span>

            <img v-if="item.url || item.link" :src="item.url ? item.url : item.link" width="30" height="30" />
            <img v-if="item.engrave" :src="item.engrave.image.url" width="35" height="35" class="rounded-full border" />
            <span
                v-if="selected"
                class="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600"
            >
                <SvgIcon
                    name="check"
                    :size="18"
                />
            </span>
            </li>
        </ListboxOption>
        </ListboxOptions>
    </transition>
    </div>
</Listbox>
</template>

<script>
import { ref, watch } from 'vue';
import {
  Listbox,
  ListboxLabel,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
} from '@headlessui/vue';
import SvgIcon from 'UI/SvgIcon';
import { usePage } from '@inertiajs/inertia-vue3';

export default {
    components: {
        Listbox,
        ListboxLabel,
        ListboxButton,
        ListboxOptions,
        ListboxOption,
        SvgIcon,
    },

    props: ['label', 'data', 'modelValue', 'noneOption', 'id', 'name', 'disabled', 'textBefore', 'textAfter'],
    emits: ['update:modelValue'],

    setup(props, { emit }) {
        const options = props.data;
        const selectedValue = ref(props.modelValue);

        const errorMessage = ref(null);

        watch(selectedValue, (val, prevVal) => {
            emit('update:modelValue', val);

            errorMessage.value = null;
        })

        watch( () => usePage().props.value.errors, (error, oldError) => {
            if(props.name || props.id) errorMessage.value = error[props.name ? props.name : props.id];
        })

        return {
            options,
            selectedValue,

            errorMessage,
        }
    },

    watch: {
        modelValue(val) {
            this.selectedValue = val;
        }
    }
}
</script>
